import format from 'date-fns/format';
import { ChatContentMedia, UserResponse } from '../../../server/types';
import { ConversationContentMeta, JobOfferContentMeta } from '../../../server/types/job-offer.types';
import {StyledOfferCard} from './styles';
import JobOfferDetails from '../chat-job-offer-details/JobOfferDetails';
import { Icon, Typography } from '../../../../core/components';
import { colorTheme } from '../../../../core/configs';
import { useToast } from '../../../../core/components/toast';
import { MouseEvent } from 'react';
import { isUsingBrowser } from '../../../utils/random.util';
import axios from 'axios';
import {Browser} from '@capacitor/browser';

interface ChatJobOfferAcceptedProps {
  sender?: UserResponse
  recipient?: UserResponse
  meta: JobOfferContentMeta
  offer: ConversationContentMeta
  date: Date
}

const ChatGeneratedContract = (props: ChatJobOfferAcceptedProps) => {
  const {presentToast} = useToast();

  const downloadFile = async (contractUrl: string) => {
    if (isUsingBrowser()) {
      try{
        const url = contractUrl;
          console.log(url)
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'contract');
          document.body.appendChild(link);
          link.click();
          showSuccessToast();
      } catch {
        showErrorToast();
      }
    } else {
      await Browser.open({url: contractUrl});
      showSuccessToast();
    }
  };

  const showSuccessToast = () => {
    presentToast({
      message: 'Downloaded successfully.',
      variant: 'success',
      position: 'bottom',
    });
  };

  const showErrorToast = () => {
    presentToast({
      message: 'Download failed.',
      variant: 'error',
      position: 'bottom',
    });
  };

  return (
    <StyledOfferCard className="msg-right">
      <div className="offer-details ">
        <div className="text-center">
          <label className="txt-heading">AUTO GENERATED CONTRACT</label>
        </div>

        <Typography 
          label="Tap the file below to download the generated contract."
          variant='f1'
          color={colorTheme.black}
          align='left'
          className='mx-2'
        />

        <div className='flex justify-center items center space-x-1 cursor-pointer w-min-fit' onClick={() => downloadFile(props.meta.ContractUrl ?? '')}>
          <Icon className='self-center' name="paperclip" size={15} color={colorTheme.primary} />
            <Typography 
              label={`auto-gen-contract-${props.meta.ContractUrl?.split('/').pop()}`}
              variant='f1'
              color={colorTheme.primary}
              align='center'
              weight='semibold'
            />
        </div>

        <div className="text-right offer-msg-time">
          <span>{`${format(props.date, 'PP')} ${format(props.date, 'p')}`}</span>
        </div>
      </div>
    </StyledOfferCard>
  );
};

export default ChatGeneratedContract;
